import { lazyLoad } from 'utils/loadable';

export const RecoverPassword = lazyLoad(
  () => import('./recoverPassword.page'),
  (module) => module.RecoverPassword
);
